import * as React from 'react'

function SvgGbEng(props) {
	return (
		<svg viewBox="0 0 25 15" width="1em" height="1em" {...props}>
			<path fill="#FFF" d="M0 0h25v15H0z" />
			<g fill="#CE1124">
				<path d="M11 0h3v15h-3z" />
				<path d="M0 6h25v3H0z" />
			</g>
		</svg>
	)
}

export default SvgGbEng
